import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { useLocation, useNavigate } from "react-router-dom";
import UserDetailsSideBar from "./DetailsSidebar";
import { API_GET_USERID } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import MyPaymentTab from "./MyPaymentTab";
import UserBookingScreen from "./MyBookingsTab";
import PathList from "../../Common/PathList";

const UserDetailsScreen = () => {
  const location = useLocation();
  const [userDetails, setUserDetails] = useState({});
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);
  let id = location?.state;
  const getData = async (id) => {
    try {
      let res = await API_GET_USERID(API_endspoints.getuserbyid, id);
      res?.s && setUserDetails(res.r);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getData(id);
  }, [id]);

  
  return (
    <Box sx={{ height: "calc(100vh)", background: "#F4F4F4" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
          px: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            width: "calc(100% - 180px)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              mr: 2,
              boxSizing: "border-box",
            }}
          >
            <ArrowBackIosRoundedIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(PathList._User)}
            />
          </Box>
          <Typography
            sx={{
              fontSize: "26px",
              fontWeight: 500,
            }}
          >
            User Details
          </Typography>
        </Box>
        <Box
          sx={{
            background: "#DEE6F2",
            display: userDetails?.role === 2 ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            p: "10px 12px",
            borderRadius: "12px",
            color: "#164FA1",
            cursor: "pointer",
            width: "180px",
          }}
          onClick={() =>
            navigate(
              `${PathList._PartnerDetails}/${userDetails?.company_details?.id}`
            )
          }
        >
          Business Details
        </Box>
      </Box>
      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 160px)",
          width: "100%",
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          gap: 2,
        }}
      >
        <UserDetailsSideBar handleData={getData} data={userDetails} />
        <Box
          sx={{
            width: "calc(100% - 240px)",
            display: "flex",
            justifyContent: "srart",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box sx={{ width: "100%", display: "flex", gap: 1 }}>
            <Box
              sx={{
                color: currentTab === 0 && `#164FA1`,
                border: currentTab === 0 && "1px solid #164FA1",
                background: currentTab === 0 ? `#DEE6F2` : "White",
                borderRadius: "8px",
                py: 1,
                px: 2,
                cursor: "pointer",
              }}
              onClick={() => setCurrentTab(0)}
            >
              Booking History
            </Box>
            <Box
              sx={{
                color: currentTab === 1 && `#164FA1`,
                border: currentTab === 1 && "1px solid #164FA1",
                background: currentTab === 1 ? `#DEE6F2` : "White",
                borderRadius: "8px",
                py: 1,
                px: 2,
                cursor: "pointer",
              }}
              onClick={() => setCurrentTab(1)}
            >
              Payment History
            </Box>
          </Box>
          {currentTab === 0 ? <UserBookingScreen /> : <MyPaymentTab />}
        </Box>
      </Box>
    </Box>
  );
};

export default UserDetailsScreen;
